import React, { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { PlayCircle, RefreshCw, Download, FileText } from "lucide-react";
import { StatusBadge } from "./Referrals";

const STATUSES = ["", "scheduled", "processing", "completed", "failed"];

export default function Payouts() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState("");

  const load = async () => {
    setLoading(true);
    const { data } = await api.get(`/payouts${status ? `?status=${status}` : ""}`);
    setItems(data);
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  const runAll = async () => {
    const { data } = await api.post("/payouts/run-scheduled");
    setToast(`Processed ${data.processed} scheduled payouts`);
    setTimeout(() => setToast(""), 3500);
    load();
  };

  const retry = async (id) => {
    await api.post(`/payouts/${id}/process`);
    load();
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight text-[#1a1c19] sm:text-3xl">Payouts</h1>
          <p className="text-sm text-[#5c665a]">M-Pesa B2C disbursements (simulated).</p>
        </div>
        <div className="flex items-center gap-2">
          <a className="admin-btn-ghost" href={`${API}/exports/payouts.csv`} download data-testid="export-payouts-csv">
            <Download className="h-4 w-4" /> Payouts CSV
          </a>
          <a className="admin-btn-ghost" href={`${API}/exports/reconciliation.csv`} download data-testid="export-recon-csv">
            <FileText className="h-4 w-4" /> Reconciliation
          </a>
          <select value={status} onChange={(e) => setStatus(e.target.value)} className="admin-input max-w-[160px]">
            {STATUSES.map((s) => <option key={s || "all"} value={s}>{s || "All"}</option>)}
          </select>
          <button className="admin-btn-pink" onClick={runAll} data-testid="run-payouts-btn">
            <PlayCircle className="h-4 w-4" /> Run scheduled
          </button>
        </div>
      </div>

      {toast && <div className="rounded-lg bg-[#eaf8de] px-4 py-2 text-sm font-semibold text-[#3f7c21]">{toast}</div>}

      <div className="admin-card overflow-x-auto p-0">
        <table className="min-w-full text-sm">
          <thead className="bg-[#fafcfa] text-left text-xs uppercase tracking-wider text-[#5c665a]">
            <tr>
              <th className="px-4 py-3">Referrer</th>
              <th className="px-4 py-3">Amount</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">M-Pesa ref</th>
              <th className="px-4 py-3">Attempts</th>
              <th className="px-4 py-3">Updated</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#e2e8e2]" data-testid="payouts-table">
            {loading ? (
              <tr><td colSpan={7} className="px-4 py-6 text-center text-[#5c665a]">Loading…</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={7} className="px-4 py-6 text-center text-[#5c665a]">No payouts yet.</td></tr>
            ) : items.map((p) => (
              <tr key={p.id}>
                <td className="px-4 py-3">
                  <div className="font-semibold">{p.referrer_name}</div>
                  <div className="text-xs text-[#5c665a]">{p.referrer_phone}</div>
                </td>
                <td className="px-4 py-3 font-semibold">KES {p.amount}</td>
                <td className="px-4 py-3"><StatusBadge s={p.status} /></td>
                <td className="px-4 py-3 font-mono text-xs">{p.mpesa_ref || "—"}</td>
                <td className="px-4 py-3 text-xs">{p.attempts}</td>
                <td className="px-4 py-3 text-xs text-[#5c665a]">{p.updated_at?.slice(0, 16).replace("T", " ")}</td>
                <td className="px-4 py-3 text-right">
                  {(p.status === "scheduled" || p.status === "failed") && (
                    <button className="admin-btn-ghost" onClick={() => retry(p.id)} data-testid={`retry-${p.id}`}>
                      <RefreshCw className="h-3.5 w-3.5" /> {p.status === "failed" ? "Retry" : "Process"}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
